<template>
  <div class="partner">
    <div class="partner-cases">
      <div class="partner-case">
        <img src="../../static/images/partner/1.png" />
        <img src="../../static/images/partner/2.png" />
        <img src="../../static/images/partner/3.png" />
        <img src="../../static/images/partner/4.png" />
        <img src="../../static/images/partner/5.png" />
        <img src="../../static/images/partner/7.png" />
        <img src="../../static/images/partner/8.png" />
        <img src="../../static/images/partner/1.png" />
        <img src="../../static/images/partner/2.png" />
        <img src="../../static/images/partner/3.png" />
        <img src="../../static/images/partner/4.png" />
        <img src="../../static/images/partner/5.png" />
        <img src="../../static/images/partner/7.png" />
        <img src="../../static/images/partner/8.png" />
      </div>
      <div class="partner-case">
        <img src="../../static/images/partner/8.png" />
        <img src="../../static/images/partner/7.png" />
        <img src="../../static/images/partner/2.png" />
        <img src="../../static/images/partner/1.png" />
        <img src="../../static/images/partner/2.png" />
        <img src="../../static/images/partner/3.png" />
        <img src="../../static/images/partner/1.png" />
        <img src="../../static/images/partner/1.png" />
        <img src="../../static/images/partner/3.png" />
        <img src="../../static/images/partner/1.png" />
        <img src="../../static/images/partner/2.png" />
        <img src="../../static/images/partner/1.png" />
        <img src="../../static/images/partner/2.png" />
        <img src="../../static/images/partner/3.png" />
        <img src="../../static/images/partner/24.png" />
      </div>
      <div class="partner-case">
        <img src="../../static/images/partner/1.png" />
        <img src="../../static/images/partner/1.png" />
        <img src="../../static/images/partner/21.png" />
        <img src="../../static/images/partner/22.png" />
        <img src="../../static/images/partner/23.png" />
        <img src="../../static/images/partner/24.png" />
        <img src="../../static/images/partner/25.png" />
        <img src="../../static/images/partner/26.png" />
        <img src="../../static/images/partner/27.png" />
        <img src="../../static/images/partner/28.png" />
        <img src="../../static/images/partner/4.png" />
        <img src="../../static/images/partner/3.png" />
        <img src="../../static/images/partner/31.png" />
        <img src="../../static/images/partner/32.png" />
        <img src="../../static/images/partner/33.png" />
      </div>
      <div class="partner-case">
        <img src="../../static/images/partner/34.png" />
        <img src="../../static/images/partner/42.png" />
        <img src="../../static/images/partner/8.png" />
        <img src="../../static/images/partner/1.png" />
        <img src="../../static/images/partner/2.png" />
        <img src="../../static/images/partner/3.png" />
        <img src="../../static/images/partner/2.png" />
        <img src="../../static/images/partner/4.png" />
        <img src="../../static/images/partner/24.png" />
        <img src="../../static/images/partner/25.png" />
        <img src="../../static/images/partner/26.png" />
        <img src="../../static/images/partner/28.png" />
        <img src="../../static/images/partner/4.png" />
        <img src="../../static/images/partner/3.png" />
        <img src="../../static/images/partner/1.png" />
      </div>
      <div class="partner-cases-title">
        <div class="partner-cases-title-mask">
          累计服务超过<span class="num">600+</span>企业单位
        </div>
      </div>
    </div> </div>
</template>

<script>
import Swiper from "swiper";
export default {
  name: "Partner",
  props: {
    partnerInfo: Array,
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    imgSwiper() {
      var swiper = new Swiper(".partner-swiper-container", {
        autoplay: {
          disableOnInteraction: false,
          delay: 1500,
        },
        loop: true,
        slidesPerView: 7,
        centeredSlides: true,
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varible.styl';

.partner-swiper-container {
  text-align: center;
  height: 700px;

  img {
    height: 100%;
  }
}

.partner >>> .partner-swiper-container {
  padding: 50px 0;
  overflow: hidden;

  .swiper-slide {
    img {
      filter: grayscale(100%);
      opacity: 0.1;
    }
  }

  .swiper-slide-active {
    box-shadow: 0 0 30px #e6e6e6;

    img {
      filter: grayscale(0);
      opacity: 1;
    }
  }
}

.partner {
  margin: 0 auto;
  // padding:60px 0 132px;
}

@keyframes rowleft {
  0% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  100% {
    -webkit-transform: translate3d(-1840px, 0, 0);
    transform: translate3d(-1840px, 0, 0);
  }
}

.partner-cases {
  position: relative;
  height: 300px;
  overflow: hidden;

  .partner-case {
    width: 3680px;
    white-space: nowrap;
    height: 0px;
    margin: 70px 0;
    -webkit-animation: 60s rowleft linear infinite normal;
    animation: 60s rowleft linear infinite normal;

    .partner-case-logo {
      width: 230px;
    }

    .partner-case-logo:nth-child(even) {
      left: 100%;
    }
  }

  .partner-case:first-child {
    margin-top: 25px;
  }

  .partner-case:nth-child(even) {
    -webkit-animation: 80s rowleft linear infinite normal;
    animation: 80s rowleft linear infinite normal;

    .partner-case-logo {
      -webkit-filter: blur(1px);
      -moz-filter: blur(1px);
      -ms-filter: blur(1px);
      filter: blur(1px);
    }
  }

  .partner-cases-title {
    position: absolute;
    top: 105px;
    width: 100%;
    text-align: center;
    font-size: 16px;
    color: #302828;
    line-height: 1;
    font-weight: 300;

    .partner-cases-title-mask {
      display: inline-block;
      width: 300px;
      height: 50px;
      line-height: 60px;
      background: rgba(255, 255, 255, 0.4);
      border-radius: 50px;
      text-align: center;
      box-shadow: 0px 0px 30px 30px rgba(255, 255, 255, 0.4);
      font-weight: bold;
    }
  }

  .partner-cases-title-mask .num {
    color: #FFC000;
  }

  .partner-cases-title .partner-cases-title-number {
    width: 100px;
    margin-top: -5px;
  }

  .partner-cases-title text {
    color: #FC3D34;
    margin: 0 10px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/mobile/Partner.vue